import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faArrowRight,
  faSpinnerThird,
} from '@fortawesome/pro-solid-svg-icons';


library.add(
  faArrowRight,
  faSpinnerThird,
);
